import { memo } from 'react';
import { inputFieldConfig } from '@velocity-exchange/common/format';
import TradeInput from 'src/components/Inputs/TradeInput';
import { numberFormatPropsFromConfig } from 'src/components/primitives/Input/numberFormatProps';
import Input from 'src/components/primitives/Input/Input';
import RadioGroup from 'src/components/primitives/RadioGroup/RadioGroup';
import DefinitionTooltip from 'src/components/Tooltip/DefinitionTooltip/DefinitionTooltip';
import useScaledOrderCountInput from 'src/components/TradeForm/ScaledOrderCountInput/hooks/useScaledOrderCountInput';
import { cm } from 'src/utils/classNames';

export const NUMBER_FORMAT_PROPS = numberFormatPropsFromConfig(
	inputFieldConfig('orderCount')
);

function ScaledOrderCountInput() {
	const {
		currentValue,
		newBrandPresetOptions,
		customInputValue,
		currentValueSource,
		handleBlur,
		handleFocus,
		handleCustomInputChange,
		handlePresetClick,
		isMobileScreenSize,
	} = useScaledOrderCountInput();

	if (isMobileScreenSize) {
		return (
			<TradeInput
				id="order-count"
				label="Order Count"
				onChange={handleCustomInputChange}
				value={customInputValue}
				onBlur={handleBlur}
				onFocus={handleFocus}
				numberFormatProps={NUMBER_FORMAT_PROPS}
				dataTestId="trade-form-order-count"
			/>
		);
	}

	return (
		<div className="flex w-full flex-col gap-y-sm">
			<DefinitionTooltip
				key="order-count"
				definitionId="tradingOrderCount"
				className="w-fit typo-body-xs text-text-secondary"
			>
				Order Count
			</DefinitionTooltip>
			<div className="flex items-stretch gap-x-xs">
				<div className="basis-1/3">
					<Input
						labelVariant="none"
						type="number"
						placeholder="Custom"
						onChange={handleCustomInputChange}
						value={customInputValue}
						onBlur={handleBlur}
						onFocus={handleFocus}
						numberFormatProps={NUMBER_FORMAT_PROPS}
						dataTestId="trade-form-order-count"
					/>
				</div>
				<RadioGroup.Default
					size="sm"
					variant="card"
					className="grow items-stretch gap-x-xs self-stretch"
					items={newBrandPresetOptions.map((item) => ({
						...item,
						className: cm(item.className, 'h-full'),
					}))}
					value={
						currentValueSource === 'preset'
							? currentValue.toString()
							: undefined
					}
					onValueChange={(value) => handlePresetClick(Number(value))}
					itemTestIdPrefix="trade-form-order-count-preset"
				/>
			</div>
		</div>
	);
}

export default memo(ScaledOrderCountInput);
